import { Box, styled } from "@mui/material";

import Colors from "../../../global/Colors";
import EmptyIcon from "../../icons/EmptyIcon";

const StyledGridOverlay = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  "& .no-rows-primary": {
    fill: Colors.gray[600],
  },
  "& .no-rows-secondary": {
    fill: Colors.gray[800],
  },
}));

export default function Empty() {
  return (
    <StyledGridOverlay>
      <EmptyIcon />
      <Box sx={{ mt: 2 }}>No data found</Box>
    </StyledGridOverlay>
  );
}
